import { SecurityConfig, SecurityImplementation } from "@csx/security"
import { environment } from '../../environments/environment';

export const SecConfig: SecurityConfig = {

  implementation: SecurityImplementation.Oidc,
  groups: [
    { name: 'client.atam.eic', roles: ['client.atam.eic'] }
  ],
  securityDomains: environment.appConfig.security.securityDomains,
  configuration: {
    clientId: environment.appConfig.security.clientId,
    autoConfigUrl: environment.appConfig.security.autoConfigUrl,
    autoLogin: false, // Login and logout are handled automatically
    silentRenew: true,
    routes: {
      logoutUrl: location.origin + '/unauthorized',
      redirectUrl: location.origin,
      silentRenewUrl: location.origin + '/assets/admin/silent-renew.html',
      forbiddenRoute: location.origin + '/unauthorized'
    },
    scopes: ['profile', 'email', 'phone', 'address'],
    handleError:true,
    diagnostics: {
      logDebug: false,
      logWarning: false
    }
  }
};
